export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./home.vue?vue&type=template&id=8f17b942&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/home.vue?vue&type=template&id=8f17b942&scoped=true
// module id = ZO8M
// module chunks = 0